import ENDPOINTS from '../../const/endpoints';
export var ExecutionCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType;
    return [ENDPOINTS.refundExecution, { accountId: accountId, accountIdType: accountIdType }];
};
